import { Action } from './action';

export class ForceUpdate extends Action {}

export class ResetForcedUpdate extends Action {}

export class RecommendUpdate extends Action {
    constructor(public version: string) {
        super();
    }
}

/**
 * Dismiss the currently raised update recommendations.
 * These will only be shown again if the API resends the recommendation again.
 * This is mostly useful when you are expecting the user to update the app.
 */
export class DismissUpdateRecommendations extends Action {}

/**
 * Ignore the currently raised update recommendations forever.
 */
export class IgnoreUpdateRecommendations extends Action {}
